module.exports = __webpack_public_path__ + "img/bgp06.0e7cdf2d.jpg";